import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import VehicleServices from '../../../services/VehicleServics';
import UserServices from '../../../services/UserServices';

const AssignDriver = ({ show, store, handleClose, item }) => {
  const [driverIds, setDriverIds] = useState([]);
  const [drivers, setDrivers] = useState([]);

  // Fetch drivers when the modal opens
  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await UserServices.getStoreDriver(store);
        if (response.data) {
          setDrivers(response.data.map(driver => ({ label: driver.name, value: driver._id })));
        }
      } catch (error) {
        console.error('Failed to fetch drivers', error);
      }
    };

    fetchDrivers();
  }, [store]);

  // Populate assigned drivers when the modal opens and when drivers list is updated
  useEffect(() => {
    if (item && drivers.length > 0) {
      const assigned = item.assignedDrivers?.map(driver => ({
        value: driver._id,
        label: driver.name,
      })) || [];
      setDriverIds(assigned);
    }
  }, [item, drivers]);

  const handleDriverChange = (selectedOptions) => {
    setDriverIds(selectedOptions);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!driverIds.length) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please select at least one driver!',
      });
      return;
    }

    try {
      const response = await VehicleServices.updateVehicle(item._id, { driverIds: driverIds.map(d => d.value) });
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Good job!',
          text: 'Drivers have been successfully assigned!',
        });
        handleClose();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: response.message || 'An error occurred while updating.',
        });
      }
    } catch (error) {
      console.error('Failed to assign drivers', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Failed to assign drivers.',
      });
    }
  };

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>
            <i className="fas fa-edit"></i> Assign Drivers
          </Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="12" className="mb-3">
                <label>Assign Drivers</label>
                <Select
                  isMulti
                  options={drivers}
                  value={driverIds}
                  onChange={handleDriverChange}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save Changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AssignDriver;
